import { AppState, User } from '@/types';
import { AppAction } from '../types';

export function handleUpdateUserProfile(state: AppState, action: AppAction): AppState {
  if (action.type !== 'UPDATE_USER_PROFILE' || !state.user) {
    return state;
  }

  console.log('🔄 Profile update reducer:', {
    oldName: state.user.name,
    newUpdates: action.payload.updates,
    newName: action.payload.updates.name
  });

  const updatedUser: User = {
    ...state.user,
    ...action.payload.updates
  };

  console.log('✅ Profile updated in state:', { newName: updatedUser.name });

  return {
    ...state,
    user: updatedUser
  };
}